import { format } from 'date-fns';
import React from 'react';

const inputelement = ({value, errors, Label, elementName, handleRegChange}) => {
    let eleValue = elementName == "DOB" || elementName == "EventDate" || elementName == "RegistrationEndDate" ? (value)=>formatDate(value): value;

    const formatDate = (date, elementName)=> {
        if(elementName == "DOB" || elementName == "EventDate" || elementName == "RegistrationEndDate"){
           let dateVal = !!date ? format(date, 'yyyy-MM-dd'): '';
            return dateVal;
        } else{
            return date
        }
      }
  return <div>
    <label htmlFor="name" className="block text-sm font-medium text-label-clr pl-1">
        {Label}
    </label>
    <input
        type= {elementName == "DOB" || elementName == "EventDate" || elementName == "RegistrationEndDate" ? "date":"text"}
        id={elementName}
        name= {elementName}
        value={formatDate(value, elementName)}
        autoComplete="off"
        className="bg-input-bg mt-1 block w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        placeholder=""
        onChange={handleRegChange}
    />
    {errors && (
        <p className="text-red-500 text-sm mt-1">{errors}</p>
    )}
    </div>;
};

export default inputelement;